import * as React from "react"
import ToolSubscriptionCard from "../components/tool-subscription-card"
import Video from "../svgs/video-solid.svg"
import FeatureSet from "../svgs/feature-set.svg"
import SyncAlt from "../svgs/sync-alt-solid.svg"
import BalanceScale from "../svgs/balance-scale-right-solid.svg"
import QuestionCircle from "../svgs/question-circle-regular.svg"
import FileAlt from "../svgs/file-alt-regular.svg"
import InteractiveTour from "../svgs/interactive-tour.svg"
import Live from "../svgs/live-solid.svg"
import HourglassHalf from "../svgs/hourglass-half-solid.svg"

const RichMediaShelf = (props) => {

    return(
        <div className='container' data-sal="slide-up" data-sal-delay="0" data-sal-duration='800' data-sal-easing="ease" style={{marginBottom: '-1.25rem'}}>
            <div className='row justify-content-center'>
                <ToolSubscriptionCard
                    title={'Video Hosting'}
                    hex={'#00aeef'}
                    color={'blue'}
                    listPrice={'$5/module/month'}
                    icon={<Video/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Give shoppers the video content they’re looking for with product videos to inform and impress."
                    sku={'vid'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'Feature Set Hosting'}
                    hex={'#1ECA8A'}
                    color={'green'}
                    listPrice={'$5/module/month'}
                    icon={<FeatureSet/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Upload and arrange additional marketing images to show off your item. Also called A+ Content."
                    sku={'fea'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'360 Views Hosting'}
                    hex={'#efc621'}
                    color={'yellow'}
                    listPrice={'$5/module/month'}
                    icon={<SyncAlt/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Use 360-degree photography to virtually put your item into the shopper’s hands."
                    sku={'deg'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'Comparison Table Hosting'}
                    hex={'#d27a7b'}
                    color={'red'}
                    listPrice={'$5/module/month'}
                    icon={<BalanceScale/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Create your own comparison tables to showcase other products on your Walmart.com listings."
                    sku={'com'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'FAQ Hosting'}
                    hex={'#7C8BDF'}
                    color={'purple'}
                    listPrice={'$5/module/month'}
                    icon={<QuestionCircle/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Create your own frequently asked questions section on Walmart.com to answer common shopper questions."
                    sku={'faq'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'Document Hosting'}
                    hex={'#6FD5F0'}
                    color={'id6'}
                    listPrice={'$5/module/month'}
                    icon={<FileAlt/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Add downloadable documents like instructions, warranty information, and more to your item pages."
                    sku={'doc'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
                <ToolSubscriptionCard
                    title={'Product Tour Hosting'}
                    hex={'#54B892'}
                    color={'id7'}
                    listPrice={'$5/module/month'}
                    icon={<InteractiveTour/>}
                    subIcon={<Live/>}
                    tooltip={'Live on Walmart.com'}
                    padding={'10%'}
                    desc="Create an interactive tour to walk shoppers through your item’s most important selling points."
                    sku={'pto'}
                    numOfItems={0}
                    price={5}
                    loggedIn={true}
                    permission={true}
                />
            </div>
        </div>
    )
}

export default RichMediaShelf;